interface Props {
  color?: string
}

const Ban = ({ color = '#000000' }: Props): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
      <circle fill="none" stroke={color} strokeMiterlimit="10" strokeWidth="48" cx="256" cy="256" r="200" />
      <line stroke={color} strokeMiterlimit="10" strokeWidth="48" x1="114.58" y1="114.58" x2="397.42" y2="397.42" />
    </svg>
  )
}

export default Ban;